import { c as _c } from "react/compiler-runtime";
import type { IconNames } from '@petsmart-ui/sparky';
import { IconMediaBlock, TextPassage } from '@petsmart-ui/sparky';
import type { CreditCardsType } from '@libs/core';
import { isLocaleCA, PaymentMethodsType } from '@libs/core';
import './PaymentMethodPreview.scss';
export type PaymentMethodPreviewProps = {
  paymentMethod: {
    type: PaymentMethodsType | string | null;
    cardType?: CreditCardsType | null;
    cardNumbers?: number | string | null;
    cardHolderName?: string;
    cardExpiryDate?: string;
  };
  promisedShipDate?: string;
};
export function PaymentMethodPreview(t0) {
  const $ = _c(24);
  const {
    paymentMethod,
    promisedShipDate
  } = t0;
  const {
    type,
    cardType,
    cardNumbers,
    cardHolderName,
    cardExpiryDate
  } = paymentMethod;
  const isCanada = isLocaleCA();
  let content;
  if (type === PaymentMethodsType.AFTERPAY) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IconMediaBlock variant="bare" iconName={isCanada ? "cc-afterpay-ca" : "cc-afterpay-us"} iconSize="4xl"><TextPassage>{PaymentMethodsType.AFTERPAY}</TextPassage></IconMediaBlock>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    content = t1;
  }
  if (type === PaymentMethodsType.PAYPAL) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IconMediaBlock variant="bare" iconName="cc-paypal" iconSize="4xl"><TextPassage>{PaymentMethodsType.PAYPAL}</TextPassage></IconMediaBlock>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    content = t1;
  }
  if (type === PaymentMethodsType.CREDITCARD) {
    let t1;
    if ($[2] !== cardType) {
      const cardName = cardType?.replaceAll(" ", "");
      t1 = cardName ? `cc-${cardName.toLowerCase()}` : "empty-credit-card";
      $[2] = cardType;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    const paymentIconName = t1 as IconNames;
    let t2;
    if ($[4] !== cardNumbers) {
      t2 = cardNumbers ? String(cardNumbers).slice(-4) : "****";
      $[4] = cardNumbers;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    const t3 = `${cardType || "N/A"} ending in ${t2}`;
    let t4;
    if ($[6] !== t3) {
      t4 = <div>{t3}</div>;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== cardHolderName) {
      t5 = cardHolderName ? <div>{cardHolderName}</div> : null;
      $[8] = cardHolderName;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    let t6;
    if ($[10] !== cardExpiryDate) {
      t6 = cardExpiryDate ? <div>{cardExpiryDate}</div> : null;
      $[10] = cardExpiryDate;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
      t7 = <TextPassage>{t4}{t5}{t6}</TextPassage>;
      $[12] = t4;
      $[13] = t5;
      $[14] = t6;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== paymentIconName || $[17] !== t7) {
      t8 = <IconMediaBlock variant="bare" iconName={paymentIconName}>{t7}</IconMediaBlock>;
      $[16] = paymentIconName;
      $[17] = t7;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    content = t8;
  }
  let t1;
  if ($[19] !== promisedShipDate) {
    t1 = promisedShipDate && <TextPassage size="sm" className="sparky-u-margin-top-sm sparky-u-padding-right-sm">You will be billed for your first Autoship on {promisedShipDate}</TextPassage>;
    $[19] = promisedShipDate;
    $[20] = t1;
  } else {
    t1 = $[20];
  }
  let t2;
  if ($[21] !== content || $[22] !== t1) {
    t2 = <div className="payment-method-preview" data-testid="payment-method" data-cs-mask={true}>{content}{t1}</div>;
    $[21] = content;
    $[22] = t1;
    $[23] = t2;
  } else {
    t2 = $[23];
  }
  return t2;
}